import { FC, SVGProps } from 'react';

export const BlastProIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="50" height="50" rx="25" fill="url(#paint0_radial_2565_745)" />
		<g filter="url(#filter0_d_2565_745)">
			<path
				d="M27.5071 25.8868C28.3567 25.8868 29.1717 25.1364 29.1327 24.2508C29.0937 23.3652 28.4174 22.6148 27.5071 22.6148C26.6573 22.6148 25.8423 23.3652 25.8814 24.2508C25.9204 25.1364 26.5967 25.8868 27.5071 25.8868Z"
				fill="white"
			/>
			<path
				d="M27.5071 25.8868C28.3567 25.8868 29.1717 25.1364 29.1327 24.2508C29.0937 23.3652 28.4174 22.6148 27.5071 22.6148C26.6573 22.6148 25.8423 23.3652 25.8814 24.2508C25.9204 25.1364 26.5967 25.8868 27.5071 25.8868Z"
				fill="url(#paint1_radial_2565_745)"
			/>
			<path
				d="M22.7984 27.8487C23.648 27.8487 24.463 27.0983 24.4241 26.2127C24.385 25.3271 23.7088 24.5767 22.7984 24.5767C21.9487 24.5767 21.1337 25.3271 21.1727 26.2127C21.2117 27.0983 21.888 27.8487 22.7984 27.8487Z"
				fill="white"
			/>
			<path
				d="M22.7984 27.8487C23.648 27.8487 24.463 27.0983 24.4241 26.2127C24.385 25.3271 23.7088 24.5767 22.7984 24.5767C21.9487 24.5767 21.1337 25.3271 21.1727 26.2127C21.2117 27.0983 21.888 27.8487 22.7984 27.8487Z"
				fill="url(#paint2_radial_2565_745)"
			/>
			<path
				d="M20.3385 23.5624C20.3462 23.5647 20.3542 23.5662 20.3622 23.567C20.7069 23.6017 21.2229 23.5404 21.6569 23.2381C22.099 22.9302 22.4378 22.385 22.4378 21.4925C22.4378 20.9579 22.4378 20.5502 22.4556 20.2246C22.4735 19.899 22.5087 19.6657 22.5746 19.4779C22.7026 19.113 22.9545 18.8923 23.5334 18.5039C24.1069 18.1191 24.6166 17.842 25.2128 17.7497C25.8075 17.6576 26.5048 17.7473 27.4537 18.1293C27.7646 18.2544 28.0288 18.3506 28.2534 18.4324C28.3639 18.4726 28.4648 18.5094 28.5569 18.5444C28.8403 18.6519 29.0468 18.7447 29.2318 18.8777C29.602 19.1441 29.9068 19.5858 30.5097 20.6966C30.6149 20.8904 30.7592 21.0858 30.9687 21.209C31.2073 21.3494 31.522 21.4744 31.8515 21.4754C32.1878 21.4765 32.5319 21.3479 32.8116 20.996C33.2103 20.4945 33.3288 20.1182 33.2735 19.7283C33.2468 19.5408 33.181 19.358 33.1017 19.1677C33.0692 19.0898 33.0354 19.0126 33.0004 18.9326C32.9467 18.8101 32.8903 18.6812 32.8317 18.5337C32.6295 18.0253 32.1824 17.4288 31.7203 16.9393C31.488 16.6932 31.2484 16.4705 31.0287 16.2961C30.8122 16.1242 30.6044 15.9907 30.4368 15.9345C30.3716 15.9126 30.2587 15.8582 30.1036 15.7835C28.9868 15.2453 25.6818 13.6525 22.2409 15.5545C21.3703 15.9653 19.7895 17.3391 19.3773 19.8447L19.3756 19.8547C19.2429 20.6615 19.0987 21.5381 19.2955 22.3698C19.4167 22.8817 19.7136 23.3827 20.3385 23.5624ZM17.4252 29.3196C16.8696 29.5992 16.7059 30.1035 16.714 30.5767C16.7264 31.3065 17.0521 32.0109 17.5175 32.5525C18.1615 33.3019 19.1716 33.9317 19.7345 34.2154C21.8218 35.3815 23.8948 35.467 25.2543 35.2725C26.0087 35.1646 26.7802 35.0316 27.5151 34.7926C29.3759 34.1875 30.1633 32.508 30.3334 31.6049C30.9329 29.3892 30.613 28.2375 30.0321 27.7117C29.7564 27.4621 29.4004 27.3852 29.0536 27.4206C28.7077 27.456 28.3614 27.6032 28.0863 27.8156C27.7249 28.0947 27.6239 28.4246 27.5727 28.8338C27.5574 28.956 27.5463 29.0839 27.5345 29.2207C27.5066 29.5437 27.4745 29.9164 27.3718 30.3814C27.1815 31.243 26.3325 31.7458 25.4901 32.0051C24.7774 32.2245 24.0383 32.4088 23.324 32.3393C22.3904 32.2485 21.1624 31.7853 20.2789 30.8962C19.9739 30.5893 19.7286 30.3125 19.5159 30.0724C19.4958 30.0497 19.4759 30.0273 19.4563 30.0051C19.2322 29.7525 19.038 29.5374 18.8468 29.3836C18.6525 29.2272 18.4519 29.126 18.2134 29.1116C17.9782 29.0975 17.7246 29.169 17.4252 29.3196Z"
				fill="white"
			/>
			<path
				d="M20.3385 23.5624C20.3462 23.5647 20.3542 23.5662 20.3622 23.567C20.7069 23.6017 21.2229 23.5404 21.6569 23.2381C22.099 22.9302 22.4378 22.385 22.4378 21.4925C22.4378 20.9579 22.4378 20.5502 22.4556 20.2246C22.4735 19.899 22.5087 19.6657 22.5746 19.4779C22.7026 19.113 22.9545 18.8923 23.5334 18.5039C24.1069 18.1191 24.6166 17.842 25.2128 17.7497C25.8075 17.6576 26.5048 17.7473 27.4537 18.1293C27.7646 18.2544 28.0288 18.3506 28.2534 18.4324C28.3639 18.4726 28.4648 18.5094 28.5569 18.5444C28.8403 18.6519 29.0468 18.7447 29.2318 18.8777C29.602 19.1441 29.9068 19.5858 30.5097 20.6966C30.6149 20.8904 30.7592 21.0858 30.9687 21.209C31.2073 21.3494 31.522 21.4744 31.8515 21.4754C32.1878 21.4765 32.5319 21.3479 32.8116 20.996C33.2103 20.4945 33.3288 20.1182 33.2735 19.7283C33.2468 19.5408 33.181 19.358 33.1017 19.1677C33.0692 19.0898 33.0354 19.0126 33.0004 18.9326C32.9467 18.8101 32.8903 18.6812 32.8317 18.5337C32.6295 18.0253 32.1824 17.4288 31.7203 16.9393C31.488 16.6932 31.2484 16.4705 31.0287 16.2961C30.8122 16.1242 30.6044 15.9907 30.4368 15.9345C30.3716 15.9126 30.2587 15.8582 30.1036 15.7835C28.9868 15.2453 25.6818 13.6525 22.2409 15.5545C21.3703 15.9653 19.7895 17.3391 19.3773 19.8447L19.3756 19.8547C19.2429 20.6615 19.0987 21.5381 19.2955 22.3698C19.4167 22.8817 19.7136 23.3827 20.3385 23.5624ZM17.4252 29.3196C16.8696 29.5992 16.7059 30.1035 16.714 30.5767C16.7264 31.3065 17.0521 32.0109 17.5175 32.5525C18.1615 33.3019 19.1716 33.9317 19.7345 34.2154C21.8218 35.3815 23.8948 35.467 25.2543 35.2725C26.0087 35.1646 26.7802 35.0316 27.5151 34.7926C29.3759 34.1875 30.1633 32.508 30.3334 31.6049C30.9329 29.3892 30.613 28.2375 30.0321 27.7117C29.7564 27.4621 29.4004 27.3852 29.0536 27.4206C28.7077 27.456 28.3614 27.6032 28.0863 27.8156C27.7249 28.0947 27.6239 28.4246 27.5727 28.8338C27.5574 28.956 27.5463 29.0839 27.5345 29.2207C27.5066 29.5437 27.4745 29.9164 27.3718 30.3814C27.1815 31.243 26.3325 31.7458 25.4901 32.0051C24.7774 32.2245 24.0383 32.4088 23.324 32.3393C22.3904 32.2485 21.1624 31.7853 20.2789 30.8962C19.9739 30.5893 19.7286 30.3125 19.5159 30.0724C19.4958 30.0497 19.4759 30.0273 19.4563 30.0051C19.2322 29.7525 19.038 29.5374 18.8468 29.3836C18.6525 29.2272 18.4519 29.126 18.2134 29.1116C17.9782 29.0975 17.7246 29.169 17.4252 29.3196Z"
				fill="url(#paint3_radial_2565_745)"
			/>
		</g>
		<defs>
			<filter
				id="filter0_d_2565_745"
				x="11.3804"
				y="12.8688"
				width="27.2393"
				height="31.3734"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="3.55556" />
				<feGaussianBlur stdDeviation="2.66667" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.688889 0 0 0 0 0.240154 0 0 0 0 0.047839 0 0 0 1 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2565_745" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2565_745" result="shape" />
			</filter>
			<radialGradient
				id="paint0_radial_2565_745"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(1.59047 46.4701) rotate(-23.5257) scale(52.794 64.2624)"
			>
				<stop stopColor="#F4933F" />
				<stop offset="0.501666" stopColor="#FF5900" />
				<stop offset="1" stopColor="#EE4C9A" />
			</radialGradient>
			<radialGradient
				id="paint1_radial_2565_745"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(27.507 24.2508) rotate(90) scale(4.24886 4.22557)"
			>
				<stop offset="0.126666" stopColor="white" />
				<stop offset="1" stopColor="#BE3198" />
			</radialGradient>
			<radialGradient
				id="paint2_radial_2565_745"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(22.7984 26.2127) rotate(90) scale(4.24886 4.22562)"
			>
				<stop offset="0.126666" stopColor="white" />
				<stop offset="1" stopColor="#BE3198" />
			</radialGradient>
			<radialGradient
				id="paint3_radial_2565_745"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(25 25) rotate(90) scale(26.8889 21.5204)"
			>
				<stop offset="0.126666" stopColor="white" />
				<stop offset="1" stopColor="#BE3198" />
			</radialGradient>
		</defs>
	</svg>
);
